import { render, staticRenderFns } from "./ManabiGrade.vue?vue&type=template&id=c4439688&scoped=true&"
import script from "./ManabiGrade.vue?vue&type=script&lang=ts&"
export * from "./ManabiGrade.vue?vue&type=script&lang=ts&"
import style0 from "./ManabiGrade.vue?vue&type=style&index=0&id=c4439688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4439688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
